import Popover, { PopoverProps } from 'client/components/core/Popover'
import React, { useState } from 'react'
import { ChevronUpIcon } from 'src/editor/shared/icons/chevron-up-icon'
import { BadgeProps } from 'src/editor/shared/ui-lib/badge'
import { DropdownProps } from 'src/editor/shared/ui-lib/dropdown'
import {
  BadgeColorEnum,
  BadgeShapeEnum,
  BadgeSizeEnum,
} from 'src/editor/shared/ui-lib/shared/badge-consts'
import {
  getBadgeDropdownCirlceColors,
  getColorClasses,
  getShapeClasses,
  getSizeClasses,
} from 'src/editor/shared/ui-lib/utils/badge-utils'
import { twMerge } from 'tailwind-merge'

export interface BadgeDropdownProps
  extends Omit<BadgeProps, 'title'>,
    Omit<DropdownProps, 'title'> {
  title: React.ReactNode
  children: React.ReactNode
  popoverProps?: Partial<PopoverProps>
}

export const BadgeDropdown = ({
  children,
  className,
  size = BadgeSizeEnum.Medium,
  shape = BadgeShapeEnum.Rounded,
  color = BadgeColorEnum.Gray,
  title,
  isDisabled,
  classNameDropdown,
  popoverProps,
}: BadgeDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      offsetValue={10}
      flipOptions={{
        fallbackAxisSideDirection: 'end',
        fallbackPlacements: ['left', 'top-start'],
      }}
      strategyValue="fixed"
      placement="bottom-start"
      triggerElement={
        <div
          className={twMerge(
            'flex w-fit items-center gap-1.5 border border-transparent outline-borderInteractive/20 transition hover:border-borderInteractive focus:outline-4',
            getSizeClasses(size),
            getShapeClasses(shape),
            getColorClasses(color),
            isOpen && 'border-borderInteractive bg-bgPrimaryBase outline-4',
            className,
          )}
        >
          <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className={twMerge(
              'relative flex w-full cursor-pointer flex-wrap items-center justify-between gap-2 border-transparent outline-none transition-all duration-100',
              isOpen
                ? 'border-inputBorder hover:border-inputBorderHover'
                : 'border-transparent',
            )}
          >
            <span className="text-M text-textTertiary">{title}</span>

            <ChevronUpIcon
              className={twMerge(
                'h-4 w-4 transition-transform duration-250',
                isOpen ? 'rotate-0' : 'rotate-180',
                isDisabled
                  ? '[&>path]:stroke-iconDisabled'
                  : getBadgeDropdownCirlceColors(color),
              )}
            />
          </button>
        </div>
      }
      popoverContent={
        <div
          className={twMerge(
            'w-50 rounded-md border-1 border-border200 bg-bgPrimaryBase p-4 pb-2.5',
            classNameDropdown,
          )}
        >
          {children}
        </div>
      }
      {...popoverProps}
    />
  )
}
